var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"shaped":""}},[_c('v-system-bar',{staticClass:"d-flex justify-end"},[_c('span',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.title))])]),_c('v-row',{attrs:{"dense":"","no-gutters":""}},[_c('v-sheet',{staticClass:"d-flex align-center mx-3"},[_vm._t("left")],2),_c('v-sheet',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }